/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ApartmentSpaceOutput.vue?vue&type=template&id=6aa1346b"
import script from "./ApartmentSpaceOutput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApartmentSpaceOutput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports